import type { CardCategoriesConfig } from '../../../shared/types/CardCategories/CardCategoriesConfig';

export const isManufacturerCardTypeEnabled = (
  cardCategoriesConfigObject: CardCategoriesConfig,
) =>
  cardCategoriesConfigObject?.some(
    (categoryConfig) =>
      categoryConfig.type === 'MANUFACTURER_CARD' &&
      categoryConfig.medications &&
      categoryConfig.medications.length > 0,
  );
